module.exports = __webpack_public_path__ + "img/p3_8.686cc077.png";